module.exports = __webpack_public_path__ + "media/src/img/payment/image1-ea54d94c2ef59f055b21691a271ef10f.png";